const promises = [
    {
        name: "Garantie 1: Altijd een Rustige Trainingsomgeving",
        description:
            "We weten hoe belangrijk een rustige omgeving is om je echt te kunnen focussen op je training. Daarom garanderen we dat er nooit meer dan tien mensen tegelijk vrij aan het trainen zijn. Zo heb je alle ruimte en rust om je volledig op jezelf te concentreren.",
        icon: "/assets/icons/dumbbell.svg",
    },
    {
        name: "Garantie 2: Trainen met Gelijkgestemden",
        description:
            "Bij WE ARE train je in een ruimte vol gelijkgestemden. Iedereen hier heeft hetzelfde doel: zich weer lekker in hun vel voelen. We garanderen dat je geen bodybuilders zult vinden die alleen maar bezig zijn met hoeveel ze kunnen tillen. Nee, bij WE ARE gaat het om jouw persoonlijke groei en welzijn.",
        icon: "/assets/icons/handshake.svg",
    },
    {
        name: "Garantie 3: Directe Communicatie met je Coach",
        description:
            "Heb je een vraag? Twijfel dan niet om deze aan je coach te stellen. Wij garanderen dat je binnen 24 uur een antwoord ontvangt. Onze coaches zijn er om jou te begeleiden en ondersteunen, elke stap van de weg.",
        icon: "/assets/icons/people-arrows-solid.svg",
    },
    {
        name: "Garantie 4: Flexibele Nazorg",
        description:
            "Wij begrijpen dat tevredenheid over de nazorg net zo belangrijk is als de training zelf. Daarom garanderen we dat ieder lid ervoor kan kiezen om zijn nazorg abonnement maandelijks opzegbaar te maken. Mocht je dan om welke reden dan ook niet tevreden zijn, kan je op elke moment jouw abonnement opzeggen. Wij willen dat je je bij ons thuis voelt, zonder enige vorm van druk.",
        icon: "/assets/icons/hand-holding-medical-regular.svg",
    },
];

export default ({ classNames = "" }) => {
    return (
        <div
            className={`relative xs:pt-8 sm:pt-8 md:pt-16 lg:pt-16 ${classNames}`}
        >
            <div className="absolute inset-0">
                <div className="bg-black h-1/3 sm:h-2/3" />
            </div>
            <div className="relative max-w-7xl mx-auto">
                <div className="text-center">
                    <h2 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                        Garanties = zekerheid
                    </h2>
                </div>
                <div className="lg:mt-24 md:mt-12 sm:mt-12 xs:mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-2 lg:max-w-none">
                    {promises.map((promise, key) => (
                        <div
                            key={key}
                            className="flex flex-col rounded-lg shadow-lg overflow-hidden"
                        >
                            <div className="flex-shrink-0">
                                <img
                                    className="h-24 w-1/2 mx-auto"
                                    src={promise.icon}
                                    alt="Personal training Uden en Schijndel"
                                />
                            </div>
                            <div className="flex-1 bg-black p-6 flex flex-col justify-between">
                                <div className="flex-1">
                                    <div className="block mt-2">
                                        <p className="text-xl font-bold text-center text-gray-100">
                                            {promise.name}
                                        </p>
                                        <p className="text-lg text-center mt-2 text-gray-100">
                                            {promise.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
